import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logger } from '@/lib/logger';

export function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait for the page to render, then scroll to the element
      setTimeout(() => {
        try {
          const targetId = hash.startsWith('#') ? hash.slice(1) : hash;
          const escaped = CSS.escape(targetId);
          const element = document.getElementById(targetId) ?? document.querySelector(`#${escaped}`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        } catch (error) {
          logger.warn('ScrollToHash', 'Skipped invalid hash selector', error);
        }
      }, 100);
    } else {
      // Scroll to top when navigating to a new page without hash
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}
